
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M11.9701 2.72999C12.1301 2.38999 11.8501 2.00999 11.4701 2.02999C5.47006 2.32999 1.00006 7.85999 2.19006 13.99C2.97006 18.02 6.28006 21.21 10.3301 21.86C14.4001 22.52 18.1001 20.72 20.2001 17.71C20.4101 17.4 20.2401 16.96 19.8701 16.92C13.1301 16.16 9.00006 8.95999 11.9701 2.72999Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-bedtime`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconBedtime

    ```js
    <b-new-b-icon-bedtime />
    ```
</docs>


